export default class WooFilterApplyButtonComponent {
  constructor(obj) {
    this.obj = obj;
    this.objQuantity = this.obj.querySelector(".ds-woo-filter__apply-button__products-quantity");
    this.listen();
  }

  clearStates() {
    this.obj.classList.remove("ds-woo-filter__apply-button--inactive");
    this.obj.classList.remove("ds-woo-filter__apply-button--loading");
  }

  enable() {
    this.clearStates();
  }

  disable() {
    this.clearStates();
    this.obj.classList.add("ds-woo-filter__apply-button--inactive");
  }

  pending() {
    this.clearStates();
    this.obj.classList.add("ds-woo-filter__apply-button--loading");
  }

  setProductsCount(count) {
    if (!this.objQuantity) {
      return;
    }

    this.objQuantity.textContent = `${count} ${count === 1 ? "product" : "products"}`;
    this.enable();
  }

  listen() {
    this.obj.addEventListener("click", () => {
      this.onClick();
      this.pending();
    });
  }

  onClick() {}
}
